import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";

import { AppModule } from "./app/app.module";
import { AppComponent } from "./app/app.component";
import { environment } from "./environments/environment";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideHttpClient } from "@angular/common/http";
import { provideRouter } from "@angular/router";
import { appRoutes } from "./app/app.routing";

if (environment.production) {
    enableProdMode();
}

if (process.env.NODE_ENV === "production") {
    // NOTE: This ENV value is being provided by Webpack's DefinePlugin. It is populated
    // on the mode in which the webpack-cli was invoked.
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideHttpClient(),
        provideRouter(appRoutes),
        // if you still have NgModules that provide services/pipes/directives you need:
        importProvidersFrom(AppModule)
    ]
}).catch(err => {
    // eslint-disable-next-line no-console
    console.error(err);
});
